var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisacard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip07182)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.3074 12.0232L12.5509 22.9542H15.3585L17.114 12.0232H14.3074ZM22.7764 16.4759C21.7952 15.9914 21.1937 15.6643 21.1937 15.1688C21.2057 14.7182 21.7024 14.2566 22.8114 14.2566C23.7236 14.2337 24.394 14.4481 24.9027 14.6614L25.1575 14.7751L25.5392 12.488C24.9846 12.2737 24.1053 12.0375 23.0192 12.0375C20.2465 12.0375 18.2942 13.479 18.2821 15.5408C18.2592 17.0622 19.6798 17.9065 20.7431 18.413C21.8292 18.9325 22.1989 19.2694 22.1989 19.731C22.1869 20.4397 21.3207 20.7667 20.5124 20.7667C19.3924 20.7667 18.7908 20.5983 17.8776 20.2034L17.5079 20.035L17.1152 22.4117C17.7748 22.7049 18.9877 22.9629 20.2467 22.9761C23.1932 22.9761 25.1106 21.5564 25.1347 19.3591C25.1443 18.1538 24.3951 17.2305 22.7764 16.4759ZM32.7371 12.057H30.5649C29.8955 12.057 29.3869 12.2496 29.0971 12.9364L24.9265 22.9542H27.8731L28.6846 20.7853H31.9813L32.4023 22.9629H35.0011L32.7371 12.057ZM29.5018 18.5965C29.5587 18.602 30.6328 15.056 30.6328 15.056L31.4881 18.5965C31.4881 18.5965 30.0564 18.5965 29.5018 18.5965ZM10.2048 12.0232L7.45401 19.4498L7.15435 17.9852C6.64572 16.2953 5.05109 14.459 3.27148 13.5468L5.7904 22.9433H8.76109L13.1755 12.0244H10.2048V12.0232Z",
    fill: "#2394BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.22784 13.4316C6.01347 12.5981 5.32982 12.036 4.40133 12.024H0.044865L0 12.2262C3.39835 13.064 6.25075 15.642 7.17613 18.0668L6.22784 13.4316Z",
    fill: "#EFC75E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip07182"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisacard);
export default __webpack_public_path__ + "static/media/visacard.819f4020.svg";
export { ForwardRef as ReactComponent };